import React, {Component, ReactElement} from 'react'
import NatLoginRepo from './repository/NatLoginRepo'
import NatLoginBeforeMessageRepo from '../loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import {NatGetLoginBeforeMessageList} from '../loginBeforeMessage/repository/NatGetLoginBeforeMessageList'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {PrimaryStyledButton, SecondaryButton, PlainForwardLinkStyledButton} from '../../../styledComponents/Button'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {MainContainer} from '../../../styledComponents/ContentsArea'
import {DisplayBlockDiv, FieldErrorLabel, TitleErrorLabel,} from '../../../styledComponents/DisplayItem'
import {AVAILABLE_SITE, DO_OR_NOT} from '../../../CodeMaster'
import NatResidentLoginBeforeMessageComponent from './resident/NatResidentLoginBeforeMessageComponent'
import {SortOrder} from '../../../components/shared/SortOrder'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {Box} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {HKConstants} from '../../../HKConstants'
import NatSessionRepo from '../session/repository/NatSessionRepo'
import {CookieHelper} from '../../../CookieHelper'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {LeftRowFlexContainer, RightRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Phone} from '@mui/icons-material'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Location} from 'react-router-dom'
import {InlineLink} from '../../../styledComponents/residentPage/Links'
import {NatCreateGenerateRequestParam} from '../residentUser/repository/NatCreateGenerateRequestParam';
import NatResidentUserRepo, {
    CreateAuthorizeRequest,
    SetSeverSessionInfoRequest
} from '../residentUser/repository/NatResidentUserRepo';
import {NatCreateAuthorizeUrl} from '../residentUser/repository/NatCreateAuthorizeUrl';
import {NatSetServerSessionInfo} from '../residentUser/repository/NatSetServerSessionInfo';


const KEY_SENI_URL = 'seniUrl'
const LOGIN_PAGE = 'loginPage'

// 検索条件
interface SearchCondition {
    publishStartDatetime: string
    publishEndDatetime: string
}

// 検索条件（ページ情報）
interface SearchConditionPage {
    sortKey: string
    sortOrder: string
}

interface Props {
    residentLoginRepo: NatLoginRepo
    loginBeforeMessageRepo: NatLoginBeforeMessageRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location
    sessionRepo: NatSessionRepo
    residentUserRepo: NatResidentUserRepo
}

interface State {
    loginBeforeMessageList: NatGetLoginBeforeMessageList | null,
    currentDateTime: CurrentDateTime,
    searchCondition: SearchCondition,
    searchConditionPage: SearchConditionPage
    errorLoginMessage: string
    errorTitleMessage: string
    titleMessage: string
    detailMessage: string
    isLoadCompleted: boolean
    backgroundLoginSite: AVAILABLE_SITE
    isOpenMultipleLoginWarningDialog: boolean
}

const KEY_LOGIN_ID: string = 'loginId'


class NatResidentLoginPage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        let titleMessage: string = ''
        const sessionTimeOut: string = getQueryParameter('sessionTimeOut', window.location.href)
        if (this.props.location.state && this.props.location.state.message) {
            // 遷移元から指定されたメッセージがあれば、設定
            titleMessage = this.props.location.state.message
        } else if (sessionTimeOut === DO_OR_NOT.DO.value) {
            titleMessage = Messages.ESYCC0021.toString()
        }

        this.state = {
            loginBeforeMessageList: null,
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            searchCondition: {
                publishStartDatetime: '',
                publishEndDatetime: '',
            },
            searchConditionPage: {
                sortKey: 'publishStartDate',
                sortOrder: 'desc',
            },
            errorLoginMessage: '',
            errorTitleMessage: '',
            titleMessage: titleMessage,
            detailMessage: '',
            isLoadCompleted: false,
            backgroundLoginSite: AVAILABLE_SITE.NOT_LOGIN,
            isOpenMultipleLoginWarningDialog: false,

        }

        this.sutekiUserRegister = this.sutekiUserRegister.bind(this)
        this.residentUserApply = this.residentUserApply.bind(this)
        this.handleLoginButtonClick = this.handleLoginButtonClick.bind(this)
        this.handleOkButtonClick = this.handleOkButtonClick.bind(this)
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
        this.handleClickContactUsPageButton = this.handleClickContactUsPageButton.bind(this)
    }

    async componentDidMount(): Promise<void> {

        // cookieのメールアドレス設定
        const mailAddress = CookieHelper.getStringValue(KEY_LOGIN_ID)
        await this.props.eventEmitter.showLoading()
        try {
            // ログアウトボタンを押下せずにログイン画面へ遷移した場合はログアウト処理を行う。
            if (sessionStorage.length > 0) {
                await this.logoutProcedure()
            }

            // 現在日時取得
            const currentDateTime: Nullable<NatGetCurrentDateTime> =
                await NatAsyncCallFunction(
                    this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                        this.props.currentDateTimeRepo), this.props.navigate)
            if (currentDateTime) {
                const searchCondition: SearchCondition = {
                    publishStartDatetime: (currentDateTime.details) ?
                        formatDateTimeForUpdateDate(currentDateTime.details.currentDateTime) : '',
                    publishEndDatetime: (currentDateTime.details) ?
                        formatDateTimeForUpdateDate(currentDateTime.details.currentDateTime) : '',
                }
                const searchConditionPage = [
                    new SortOrder('publishStartDatetime', 'desc'),
                    new SortOrder('updateDatetime', 'desc'),
                ]
                // ログイン前メッセージ取得
                const loginBeforeMessageList: Nullable<NatGetLoginBeforeMessageList> =
                    await NatAsyncCallFunction(
                        this.props.loginBeforeMessageRepo.getLoginBeforeMessageMasterList.bind(
                            this.props.loginBeforeMessageRepo,
                            searchCondition,
                            {},
                            searchConditionPage), this.props.navigate)

                this.setState({
                    loginBeforeMessageList: loginBeforeMessageList,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async logoutProcedure(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await NatAsyncCallFunction(this.props.residentLoginRepo.postLogout.bind(
                this.props.residentLoginRepo,
            ), this.props.navigate)
            await NatAsyncCallFunction(this.props.sessionRepo.postResidentUseSite.bind(
                this.props.sessionRepo,
            ), this.props.navigate)
            SessionStorageHelper.removeAllItem()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleLoginButtonClick(): Promise<void> {
        const response = await NatAsyncCallFunction(
            this.props.sessionRepo.getLoginStatus.bind(this.props.sessionRepo),
            this.props.navigate,
        )

        if (response === null) {
            return
        }
        this.setState({
            backgroundLoginSite: AVAILABLE_SITE.codeToEnumConstants(response),
        })

        if (response === AVAILABLE_SITE.NOT_LOGIN.value) {
            await this.login()
        } else {
            this.setState({
                isOpenMultipleLoginWarningDialog: true,
            })
        }
    }

    async handleOkButtonClick(): Promise<void> {
        this.setState({isOpenMultipleLoginWarningDialog: false})
        await this.logoutProcedure()
        await this.login()
    }

    handleCancelButtonClick(): void {
        this.setState({isOpenMultipleLoginWarningDialog: false})
    }

    // ログイン
    async login(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

        if (isSutekiNetSmartPhoneApplication === 'true') {
            setSessionStorage(LOGIN_PAGE, 'NatResidentLogin');
            const seniurl: string = getQueryParameter('seniurl', this.props.location.search);
            if (seniurl) {
                setSessionStorage(KEY_SENI_URL, seniurl);
            }
            const setSeverSessionInfoRequestSp: SetSeverSessionInfoRequest = {
                authenticationKey: null,
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: null,
                token: null,
                isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication
            };
            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequestSp),
                    this.props.navigate
                );
            return;
        }
        // ログイン認証の結果をリセット
        await this.clearMessage()

        let loginAuthorizationCompletedFlg = false

        await this.props.eventEmitter.showLoading()
        try {
            // メンテナンスモード判定用に、現在日時取得APIを実行
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            // ログイン認証
            // ステート、ノンス取得し、セッションへ格納
            setSessionStorage(LOGIN_PAGE, 'NatResidentLogin');
            const setSeverSessionInfoRequest: SetSeverSessionInfoRequest = {
                authenticationKey: null,
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: 'NatResidentLogin',
                token: null,
                isSutekiNetSmartPhoneApplication: null
            };
            const ret: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequest),
                    this.props.navigate
                );
            if (ret) {
                const createGenerateRequestParam: Nullable<NatCreateGenerateRequestParam> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createGenerateRequestParam.bind(
                            this.props.residentUserRepo), this.props.navigate);

                let mailAddressForParam = null;
                if (currentDateTime && currentDateTime.details) {
                    const currentDate = new Date(currentDateTime.details.currentDateTime);
                    // 2026/4/1以降は無効化
                    const cutoffDate = new Date(2026, 3, 1, 0, 0, 0, 0);
                    const isValidDate = currentDate < cutoffDate;

                    if (isValidDate) {
                        // 2026/3/31以前ならCookieからメールアドレスを取得
                        mailAddressForParam = CookieHelper.getStringValue(KEY_LOGIN_ID)
                    }
                }

                if (createGenerateRequestParam) {
                    // パラメータ作成
                    const createAuthorizeRequest: CreateAuthorizeRequest = {
                        mailAddress: mailAddressForParam ? encodeURIComponent(mailAddressForParam) : null,
                    };
                    const natCreateAuthorizeUrl: Nullable<NatCreateAuthorizeUrl> =
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.createAuthorize.bind(
                                this.props.residentUserRepo, createAuthorizeRequest), this.props.navigate);
                    if (natCreateAuthorizeUrl && natCreateAuthorizeUrl.details) {
                        loginAuthorizationCompletedFlg = true;
                        const seniurl: string = getQueryParameter('seniurl', this.props.location.search);
                        if (seniurl) {
                            setSessionStorage(KEY_SENI_URL, seniurl);
                        }
                        window.location.href = natCreateAuthorizeUrl.details;
                    }
                }
            }
        } finally {
            if (loginAuthorizationCompletedFlg) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    // 素敵ネットユーザ登録
    sutekiUserRegister(): void {
        this.props.navigate(
            `/resident/firstLoginPolicyAgree`,
        )
    }

    residentUserApply(): void {
        this.props.navigate('/resident/noAuthenticationKey/agreement')
    }

    handleClickContactUsPageButton (): void {
        window.open('/resident/contactus', '_blank');
    }

    // メッセージ設定(タイトル)
    setTitleErrorMessage(message: string): void {
        this.setState({titleMessage: message})
    }

    // メッセージ設定(詳細)
    setDetailErrorMessage(message: string): void {
        this.setState({detailMessage: message})
    }

    // メッセージ取得（タイトル）
    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.titleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.titleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    // メッセージ取得（詳細）
    getDetailErrorMessage(): Nullable<ReactElement> {
        if (this.state.detailMessage !== '') {
            return (
                <DisplayBlockDiv>
                    <FieldErrorLabel>
                        <DisplayErrorMessageLineBreak>
                            {this.state.detailMessage}
                        </DisplayErrorMessageLineBreak>
                    </FieldErrorLabel>
                </DisplayBlockDiv>
            )
        } else {
            return null
        }
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({titleMessage: '', detailMessage: ''})
    }

    renderMultipleLoginWarningDialog(
        backgroundLoginSite: AVAILABLE_SITE,
        isOpenMultipleLoginWarningDialog: boolean,
    ): Nullable<ReactElement> {
        let multipleLoginWarningDialogMessage
        if (backgroundLoginSite === AVAILABLE_SITE.ADMIN) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0001
        } else if (backgroundLoginSite === AVAILABLE_SITE.RESIDENT) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0002
        } else if (backgroundLoginSite === AVAILABLE_SITE.GUEST) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0004
        } else {
            return null
        }

        return <MessageDialogComponent
            open={isOpenMultipleLoginWarningDialog}
            params={{
                title: '確認',
                errorLevel: multipleLoginWarningDialogMessage.errorLevel,
                message: multipleLoginWarningDialogMessage.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleCancelButtonClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleOkButtonClick,
                    },
                ],
            }}
        />
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <NatResidentLoginBeforeMessageComponent loginBeforeMessageList={this.state.loginBeforeMessageList}/>
                {this.getTitleErrorMessage()}
                <Box pb={`15px`}>
                    <MainContainer>
                        <DisplayBlockDiv>
                            <BlockTitle>素敵ネットログイン</BlockTitle>
                        </DisplayBlockDiv>
                        {this.getDetailErrorMessage()}
                        <DisplayBlockDiv>
                            <PrimaryStyledButton
                                id={'loginBtn'}
                                onClick={() => this.handleLoginButtonClick()}
                            >
                                ログインする
                            </PrimaryStyledButton>
                        </DisplayBlockDiv>
                    </MainContainer>
                </Box>
                <Box pb={`15px`}>
                    <MainContainer>
                        <DisplayBlockDiv>
                            <BlockTitle>素敵ネット新規登録</BlockTitle>
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <SecondaryButton onClick={this.sutekiUserRegister}>
                                認証キーをお持ちの方
                            </SecondaryButton>
                        </DisplayBlockDiv>
                        <Box height={'15px'}/>
                        <DisplayBlockDiv>
                            <SecondaryButton onClick={this.residentUserApply}>
                                認証キーをお持ちでない方
                            </SecondaryButton>
                            <Box textAlign={'center'} fontSize={FontSize.Middle}>
                                ※お手続き完了までに数日お時間をいただきます
                            </Box>
                        </DisplayBlockDiv>
                        <HelpUserRegist>
                            <InlineLink href={`/${HKConstants.VRS.RES.USER_LOGIN_PROCEDURE_URL}`}
                                        target="_blank">ユーザ登録の手順はこちら</InlineLink>
                        </HelpUserRegist>
                    </MainContainer>
                </Box>
                <Box height={'15px'}/>
                <Box>
                    <RightRowFlexContainer>
                        <Box mt={'5px'} mr={'15px'}>
                            <PlainForwardLinkStyledButton
                                onClick={this.handleClickContactUsPageButton}
                            >
                                お問い合わせはこちら
                            </PlainForwardLinkStyledButton>
                        </Box>
                    </RightRowFlexContainer>
                    <Box mt={'10px'} textAlign={'right'} fontSize={FontSize.Middle}>
                        ログインに関する操作・管理費等ご請求金額など
                    </Box>
                </Box>
                {this.renderMultipleLoginWarningDialog(
                    this.state.backgroundLoginSite,
                    this.state.isOpenMultipleLoginWarningDialog,
                )}
            </>
        )
    }
}

export default createResidentPage(NatResidentLoginPage)

// お問い合わせ
const ContactArea: StyledDiv = styled.div`
    text-align: left;
`
// ユーザ登録の手順はこちら
const HelpUserRegist: StyledDiv = styled.div`
    text-align: center;
`

// パスワードを忘れた場合
const ForgerPassword: StyledDiv = styled.div`
    text-align: center;
`

// ブロックタイトル
const BlockTitle: StyledDiv = styled.div`
    font-weight: bold;
`

// ログインエラーメッセージ
const DisplayErrorMessageLineBreak: StyledDiv = styled.div`
    word-break: normal;
    line-break: strict;
`

const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
    align-items: flex-start;
    font-Size: ${FontSize.Small};
`

// 電話アイコン
const PhoneIcon = withStyles({
    root: {
        color: Colors.Primary,
    },
})(Phone)

function setSessionStorage(key: string, value: any | null): void {
    if (value) {
        SessionStorageHelper.setItem(key, value)
    } else {
        SessionStorageHelper.setItem(key, '')
    }
}
